import React from "react";
import DragAndDropUpload from "../../../../../_components/DragAndDrop";
import Text from "../../../../../_components/Text";
import Button from "../../../../../_components/Button";
import LoadingInput from "../../../../../_components/LoadingInput";
import { uploadCertificate } from "../../../../../api/digitalCertificates";
import { toast } from "react-toastify";

import * as colors from "../../../../../assets/_base/colors";

import Disclaimers from "../Disclaimers";

export default (props) => {
  const [certificate, setCertificate] = React.useState({});
  const [data, setData] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const inputRef = React.useRef(null);

  function validateFile(file) {
    toast.dismiss();

    if (file.type !== "application/x-pkcs12") {
      toast.error(
        <Text color="white">
          Tipo de arquivo inválido. Informe um PFX ou P12
        </Text>,
        {
          toastId: "upload-certificate-error-filetype-error",
          position: "top-center",
        }
      );
    } else {
      setCertificate(file);
      setTimeout(() => {
        console.debug(inputRef.current);
      }, 500);
    }
  }
  const onChange = (e) => {
    setData({
      password: e.target.value,
    });
  };

  const handleClickWpp = () => {};

  function upload() {
    setLoading(true);
    uploadCertificate(certificate, data.password)
      .then((resp) => {
        let headerMessage = "Seu certificado digital foi anexado";
        let bodyrMessage = "Seu certificado digital foi anexado";
        let branch = localStorage.getItem('easygestorweb_current_branch')
        if (branch) {
          branch = JSON.parse(branch);
          branch.certificate = resp
          
          localStorage.setItem('easygestorweb_current_branch', JSON.stringify(branch))
        }
        if (resp.free_plan) {
          if (resp.first_certificate) {
            headerMessage = `Seu certificado digital foi anexado, e vencerá em ${resp.expiry_date}`;
            bodyrMessage = "Parabéns! Sua assinatura Grátis foi renovada!";
          } else {
            bodyrMessage = (
              <div>
                <Text>
                  Quando você compra um certificado digital com o parceiro
                  Easygestor, você ganha créditos gratuitos novos para emissão
                  de Notas Fiscais.
                </Text>
                <Text>
                  Se você renovou conosco,{" "}
                  <Button
                    style={{
                      color: colors.successVariant,
                    }}
                    as="text"
                  >
                    Clique aqui
                  </Button>{" "}
                  para pedir seus créditos ao SUPORTE.
                </Text>
                <Text>
                  Caso não tenha renovado conosco você precisará fazer um
                  upgrade de plano. Para acessar a tela de plano{" "}
                  <Button
                    as="text"
                    style={{
                      color: colors.successVariant,
                    }}
                  >
                    Clique aqui
                  </Button>
                </Text>
              </div>
            );
          }
        }

        if (props.handleSuccess) {
          props.handleSuccess(headerMessage, bodyrMessage);
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.error) {
          let errorMessage = "";

          if (typeof error.error === "object") {
            errorMessage = error.error.join("\n");
          } else {
            errorMessage = error.error;
          }
          toast.error(<Text color="white">{errorMessage}</Text>, {
            toastId: "upload-certificate-error",
            position: "top-center",
          });
        }
        setLoading(false);
      });
  }

  return (
    <div>
      <DragAndDropUpload label={certificate.name} onDrop={validateFile} />

      <div className={`my-5 ${certificate.name ? "d-block" : "d-none"}`}>
        <Text>Senha:</Text>
        <LoadingInput
          disabled={loading}
          type="password"
          onChange={onChange}
          ref={inputRef}
        />
        <Button
          disabled={loading || !data.password}
          loading={loading}
          onClick={upload}
        >
          Importar Certificado
        </Button>
      </div>
      <Disclaimers />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/DigitalCertificate/components/UploadCertificate/index.jsx